// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1DayPropertySchema = z.object({
  id: z.number().int().describe("Unique identifier for the day property"),
  user_id: z.number().int().describe("User ID this day property belongs to"),
  account_id: z.number().int().describe("Account ID this day property belongs to"),
  date: z.string().date().describe("Date in YYYY-MM-DD format"),
  locked: z.boolean().describe("Whether the day is locked for time entry modifications"),
  updated_at: z.number().int().describe("Unix timestamp of when the day property was last updated"),
  created_at: z.number().int().describe("Unix timestamp of when the day property was created"),
});
